import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Menu } from 'src/components/shared';
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import { sequenceEnrollmentStatus } from 'src/modules/contacts/config';
import { useCallback } from 'react';
import ContactDetailsForm from 'src/modules/contacts/components/ContactDetails/ContactDetailsForm';
import { Modal } from 'src/components/shared';
import { setReEnrolmentErrors } from 'src/modules/sequence/actions/enrolmentActions';
import { useState } from 'react';
import { bounceWarningMessage } from 'src/modules/tasks/config';
import images from "../../../../../config/images";
import { fetchContact, putContactDetails } from 'src/modules/contacts/actions/contactActions';

const { IN_PROGRESS, COMPLETED, HOLD, FAILED, BOUNCED, ERROR, INTERESTED, NOT_INTERESTED } =
  sequenceEnrollmentStatus;

function MenuAction({ sequence, putEnrollment, disabled }) {
  const user = useSelector((state) => state.auth.user);
  const contact = useSelector(state => state.contacts.contact)
  const [showEmailModal, setShowEmailModal] = useState(false);
  const dispatch = useDispatch();
  const bounceEmailId = contact?.emails?.find(email => email?.email === sequence?.selectedEmailId) || {}
  const bounceWorkFlowStatus = sequence?.bounceWorkFlowStatus || ""
  const isBounceStarted = (bounceWorkFlowStatus === "started")
  const onEmailModalClose = () => setShowEmailModal(false);
  const emailConnected = useMemo(() => {
    if (user?.nlAccessToken && user?.nlAccessToken !== '') {
      return true;
    }
    return false;
  }, [user]);

  const interestedNotInterested = [
    {
      label: 'End sequence - Interested',
      icon: <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.interested} />,
      onClick: () => {
        putEnrollment(sequence.id, {
          status: `${sequence.status && INTERESTED}`,
        });
      },
    },
    {
      label: 'End sequence - Not Interested',
      icon: <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.notInterested} />,
      onClick: () => {
        putEnrollment(sequence.id, {
          status: `${sequence.status && NOT_INTERESTED}`,
        });
      },
    },
  ]

  const sequenceOptions = [
    ...(emailConnected === true
      ? [
        {
          label: `${sequence.status === IN_PROGRESS ? 'Pause' : 'Resume'}`,
          icon: <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.notificationPaused} />,
          onClick: () => {
            putEnrollment(sequence.id, {
              status: `${sequence.status === IN_PROGRESS ? HOLD : IN_PROGRESS}`,
            });
          },
        },
      ]
      : []),
    ...interestedNotInterested
  ];
  const bounceOption = [
    ...(!isBounceStarted ? [{
      label: 'Update selected email address',
      icon: <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.hardBounced} />,
      onClick: () => {
        setShowEmailModal(true);
      },
    }] : []),
    ...interestedNotInterested
  ];

  const editContactDetails = (data) => {
    return new Promise((resolve, reject) => {
      dispatch(putContactDetails(contact.id, "email", bounceEmailId.id, data, resolve, reject));
    });
  };

  const contactResponse = (emailData, type) => new Promise((resolve, reject) => dispatch(
    setReEnrolmentErrors(sequence.id, {
      reenroll: type,
      email: emailData.email,
    }, resolve, reject),
  ))

  const onNextBounceError = async (emailData, type) => {
    try {
      switch (type) {
        case "current":
          let response = await contactResponse(emailData, type);
          dispatch(fetchContact(response?.enrollment?.contact?.id || sequence?.contact?.id))
          break;
        case "mark_done":
          putEnrollment(sequence.id, {
            status: `${sequence.status && NOT_INTERESTED}`,
          })
          let emailPayload = {
            email: emailData?.email || "",
            type: emailData?.type || "work",
            isPrimary: emailData?.isPrimary || false
          }
          await editContactDetails(emailPayload)
          break;
        default:
          break;
      }
    } catch (error) {
      console.log("errrorrr", error)
    }
  };

  const getOptions = useCallback((status) => {
    switch (status) {
      case FAILED:
      case IN_PROGRESS:
      case HOLD:
      case ERROR:
        return sequenceOptions;

      case NOT_INTERESTED:
        return [
          ...sequenceOptions.slice(0, 1),
          {
            label: 'Interested',
            icon: <DoneIcon />,
            onClick: () => {
              putEnrollment(sequence.id, {
                status: `${sequence.status && INTERESTED}`,
              });
            },
          },
        ];

      case INTERESTED:
        return [
          ...sequenceOptions.slice(0, 1),
          {
            label: 'Not Interested',
            icon: <InfoIcon />,
            onClick: () => {
              putEnrollment(sequence.id, {
                status: `${sequence.status && NOT_INTERESTED}`,
              });
            },
          },
        ];

      case BOUNCED:
        return bounceOption;

      case COMPLETED:
      default:
        return sequenceOptions.slice(0, 1);
    }
  });
  return (
    <>
      <Menu
        title=""
        disabled={disabled}
        color="secondary"
        buttonStyles={{ padding: '0px' }}
        iconButton={true}
        options={getOptions(sequence.status)}
      />
      <Modal
        open={showEmailModal}
        onClose={onEmailModalClose}
        title={"Edit email address"}
        size="xs"
      >
        <ContactDetailsForm
          formType={'email'}
          formData={{ ...bounceEmailId, isBounce: true }}
          onSubmit={onNextBounceError}
          onClose={onEmailModalClose}
          submitButtonText={'Save'}
          bounceMessage={bounceWarningMessage}
        />
      </Modal>
    </>
  );
}

export default MenuAction;
